import Page, { getServerSideProps as compGetServerSideProps } from 'components/pages/Plans';

export const getServerSideProps = compGetServerSideProps;
export default Page;
